// When we want to render to primary auth and display a custom error message,
// we make use of TerminalError while triggering setTransactionError
// extra props are required to render custom error page and not the default session expired message on the screen
export class TerminalError extends Error {
  protected errorDetails: { errorSummary: string };
  protected is: (errorType: string) => boolean;
  constructor(description: string) {
    super(description);
    this.is = (errorType: string) => (errorType === 'terminal');
    this.errorDetails = { errorSummary: description };
  }
}

export class MethodNotSupportedError extends Error {
  constructor() {
    super('Method is Not Supported');
  }
}

export class PreAuthnError extends Error {
  public errorDetails: any;

  constructor(error: any) {
    super('An error occurred while fetching pre-authn configs');
    const errorMetadata = {
      isBackendError: true,
      source: 'pre-authn-ohsw',
      type: this._getErrorType(error),
    };
    if (error.responseBody && typeof error.responseBody === 'object') {
      this.errorDetails = { ...error.responseBody, statusCode: error.status, ...errorMetadata };
    }
    else {
      this.errorDetails = { error, ...errorMetadata };
    }
  }

  _getErrorType(error: any) {
    if (error.status && error.status >= 500) {
      return 'ise';
    }
    else if (error.name === 'AbortError') {
      return 'timeout';
    }
    else if (error.message === 'Failed to fetch') {
      return 'network';
    }
    return 'unknown';
  }
}

export class PhoneEnrollmentLimitExceededError extends Error {
  constructor() {
    super('Maximum allowed number of phone factors already registered');
  }
}
